module.exports = __webpack_public_path__ + "img/Picture4.6aba2aac.png";